var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table-extended',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":5,"csv-filename":"orders","loading":_vm.loading},scopedSlots:_vm._u([{key:"item.created",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(new Date(item.created).toLocaleString()))])]}},{key:"item.completed",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.completed ? 'Ja' : 'Nein'))])]}},{key:"item.metadata.newsletter",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.metadata.newsletter === 'true' ? 'Ja' : 'Nein'))])]}},{key:"item.metadata.postcard",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.metadata.postcard === 'true' ? 'Ja' : 'Nein'))])]}},{key:"item.files.org.url",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":item.files.org.url,"target":"_blank"}},[_vm._v("Upload")])]}},{key:"item.files.print.url",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":item.files.print.url,"target":"_blank"}},[_vm._v("Print")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }